import CollapseListModule from "./CollapseListModule";

export default class PopinImage{

    constructor() {
        this.elTriggers = document.querySelectorAll('.js-popin-image-trigger');
        this.elPopins = document.querySelectorAll('.js-popin-image');
        this.elClose = document.querySelectorAll('.js-popin-image-close');

        this.bindEvents();
    }

    bindEvents(){
        Array.prototype.forEach.call(this.elTriggers, (el, i) => {
            el.addEventListener('click', this.showPopin.bind(this));
        });
        Array.prototype.forEach.call(this.elClose, (el, i) => {
            el.addEventListener('click', this.hidePopins.bind(this));
        });
    }

    showPopin(e){
        let target = e.currentTarget;
        let targetId = target.getAttribute('data-target');
        let currentPopin = document.querySelector('.js-popin-image[data-id="'+targetId+'"]');
        currentPopin.classList.add('is-shown');
    }

    hidePopins(){
        Array.prototype.forEach.call(this.elPopins, (el, i) => {
            el.classList.remove('is-shown');
        });
    }

}